import React from 'react';
import { FastField, Form, Formik } from 'formik';

import { Typography, Grid, Dialog, DialogTitle, DialogContent } from '@material-ui/core';
import CustomTextField from '../../components/TextField';
import CustomDateField from '../../components/DateField';
import SaveBox from '../../components/SaveBox';
import Loading from 'app/layouts/Loading';
import _ from 'lodash';
import { useSelector } from 'react-redux';

export default function ToggleActiveModal({
    loading,
    open,
    data,
    isCurrentActive,
    onClose,
    onSubmit,
    formInitialValues,
    formValidationSchema,
    conductor = false,
    apostille = false,
    dateFieldEnabled = false,
}) {
    const selectedLine = useSelector((state) => state.line.selected);

    const renderJustifyLabel = () => {
        return isCurrentActive ? 'Motivo da inativação' : 'Motivo da ativação';
    };

    const handleSubmit = async (vls) => {
        const valuesCopy = _.cloneDeep(vls);
        valuesCopy.boAtivar = !data.boAtivo;
        if (onSubmit) onSubmit({ ...data, ...valuesCopy });
        onClose();
    };

    return (
        <Dialog fullWidth maxWidth="md" open={open} onClose={onClose} scroll="body">
            <Formik
                validateOnBlur
                enableReinitialize
                validationSchema={formValidationSchema}
                initialValues={formInitialValues}
                onSubmit={handleSubmit}>
                {(formProps) => (
                    <Form>
                        {loading && <Loading />}
                        <DialogTitle onClose={onClose} disableTypography>
                            <Typography color="secondary" variant="subtitle2">
                                {renderJustifyLabel()}
                            </Typography>
                        </DialogTitle>
                        <DialogContent dividers>
                            <Grid container spacing={4}>
                                <Grid item xs={12} container spacing={1}>
                                    <Grid item xs={12} sm={8}>
                                        <FastField
                                            component={CustomTextField}
                                            disabled
                                            label="Linha"
                                            value={selectedLine?.deDescricao}
                                        />
                                    </Grid>
                                </Grid>
                                {!conductor && !apostille && (
                                    <Grid item xs={12} sm={8}>
                                        <FastField
                                            component={CustomTextField}
                                            disabled
                                            label="Permissionário"
                                            value={data?.deNomePermissionario}
                                        />
                                    </Grid>
                                )}
                                <Grid item xs={12} sm={4}>
                                    <FastField
                                        disabled={!dateFieldEnabled}
                                        component={CustomDateField}
                                        label="Data"
                                        name="dtCadastro"
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <FastField
                                        component={CustomTextField}
                                        label={renderJustifyLabel()}
                                        name="deMotivo"
                                        multiline
                                        rows={2}
                                        inputProps={{
                                            maxLength: 2000,
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <FastField
                                        component={CustomTextField}
                                        label="Observação"
                                        name="deObservacao"
                                        multiline
                                        minRows={4}
                                        inputProps={{
                                            maxLength: 2000,
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <SaveBox onCancel={onClose} onSave={formProps.handleSubmit} removeSpacing />
                                </Grid>
                            </Grid>
                        </DialogContent>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
}
